import { render } from "./BookPreview.vue?vue&type=template&id=9b7bd7a0&scoped=true"
import script from "./BookPreview.vue?vue&type=script&lang=js"
export * from "./BookPreview.vue?vue&type=script&lang=js"

import "./BookPreview.vue?vue&type=style&index=0&id=9b7bd7a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b7bd7a0"]])

export default __exports__